module.exports = __webpack_public_path__ + "img/btn_menu_design.a68a2990.svg";